import React, { useState } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
interface LoginPageProps {
  onLogin: () => void;
}
export function LoginPage({
  onLogin
}: LoginPageProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      onLogin();
    }, 1000);
  };
  return <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0A2F14] via-[#1B5E20] to-[#2E7D32]" data-id="element-986">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-987"></div>

      <div className="relative z-10 w-full max-w-md p-8 bg-white rounded-2xl shadow-2xl" data-id="element-988">
        <div className="flex flex-col items-center mb-8" data-id="element-989">
          <div className="w-16 h-16 bg-[#1B5E20] rounded-xl flex items-center justify-center text-white mb-4 shadow-lg" data-id="element-990">
            <ShieldCheckIcon size={32} data-id="element-991" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 text-center" data-id="element-992">
            Bangladesh Forest Department
          </h1>
          <p className="text-sm text-gray-500 mt-1 font-medium tracking-wide" data-id="element-993">
            PERMIT MANAGEMENT SYSTEM
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-994">
          <div data-id="element-995">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-996">
              Email or Username
            </label>
            <input type="text" required value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20] focus:border-transparent transition-all" placeholder="Enter your credentials" data-id="element-997" />
          </div>

          <div data-id="element-998">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-999">
              Password
            </label>
            <input type="password" required value={password} onChange={e => setPassword(e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20] focus:border-transparent transition-all" placeholder="••••••••" data-id="element-1000" />
          </div>

          <div className="flex items-center justify-between" data-id="element-1001">
            <label className="flex items-center gap-2" data-id="element-1002">
              <input type="checkbox" className="w-4 h-4 text-[#1B5E20] rounded border-gray-300 focus:ring-[#1B5E20]" data-id="element-1003" />
              <span className="text-sm text-gray-600" data-id="element-1004">Remember me</span>
            </label>
            <button type="button" className="text-sm text-[#1B5E20] hover:underline font-medium" data-id="element-1005">
              Forgot password?
            </button>
          </div>

          <button type="submit" disabled={isLoading} className="w-full py-3 px-4 bg-[#1B5E20] text-white rounded-lg font-medium hover:bg-[#2E7D32] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1B5E20] transition-all disabled:opacity-70 flex items-center justify-center" data-id="element-1006">
            {isLoading ? <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" data-id="element-1007"></div> : 'Sign In'}
          </button>
        </form>

        <div className="mt-8 text-center text-xs text-gray-500" data-id="element-1008">
          &copy; {new Date().getFullYear()} Bangladesh Forest Department. All
          rights reserved.
        </div>
      </div>
    </div>;
}